
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService
} from "@azure/msal-angular";
import {
  NgbDropdownModule,
  NgbModalModule,
  NgbPopoverModule, NgbModule
} from "@ng-bootstrap/ng-bootstrap";
import { EditorModule } from "@tinymce/tinymce-angular";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { environment } from "src/environments/environment";
import { AdminModule } from "./admin/admin.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppSettingsComponent } from "./app-settings/app-settings.component";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./auth-pages/login.component";
import { LogoutComponent } from "./auth-pages/logout.component";
import { NotFoundComponent } from "./auth-pages/not-found.component";
import { PrivacyPolicyComponent } from "./auth-pages/privacy-policy.component";
import { SigninOidcComponent } from "./auth-pages/signin-oidc.component";
import { UnauthorizedComponent } from "./auth-pages/unauthorized.component";
import {
  API_BASE_URL,
  AuthApi,
  CandidateApi,
  EmailApi,
  LookupApi,
  PBApi,
  UserApi
} from "./core/api.gen";
import { AttachmentUploadService } from "./core/attachment-upload.service";
import { CommonService } from "./core/common.service";
import { CSVReportService } from "./core/csvreport.service";
import { DocumentUploadService } from "./core/document-upload.service";
import { HttpErrorInterceptor } from "./core/interceptors/http-error.interceptor";
import { TokenInterceptor } from "./core/interceptors/token-interceptor";
import { XsrfInterceptor } from "./core/interceptors/xsrf-interceptor";
import { LoaderService } from "./core/loader.service";
import { OpenFilePreviewService } from "./core/open-file-preview.service";
import { AntiForgeryResolver } from "./core/resolvers/anti-forgery.resolver";
import { TimerInterceptor } from "./core/time-out.service";
import { ExitTaskAmendEditComponent } from "./exit-task-amendment/exit-task-amend-edit/exit-task-amend-edit.component";
import { ExitTaskAmendmentComponent } from "./exit-task-amendment/exit-task-amendment.component";
import { ExitTemplateGeneratorComponent } from "./exit-template-generator/exit-template-generator.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { ImmTaskAmendmentEditComponent } from "./imm-task-amendment/imm-task-amendment-edit/imm-task-amendment-edit.component";
import { ImmTaskAmendmentComponent } from "./imm-task-amendment/imm-task-amendment.component";
import { AuthorisedLayoutComponent } from "./layouts/authorised-layout/authorised-layout.component";
import { GuestLayoutComponent } from "./layouts/guest-layout/guest-layout.component";
import { LandingPageComponent } from "./layouts/landing-page/landing-page.component";
import { LookupTypeAmendmentEditComponent } from "./lookup-type- amendment/lookup-type-amendment/lookup-type-amendment-edit/lookup-type-amendment-edit/lookup-type-amendment-edit.component";
import { LookupTypeAmendmentComponent } from "./lookup-type- amendment/lookup-type-amendment/lookup-type-amendment.component";
import { SharedModule } from "./shared/shared.module";
import { TaskAmendmentEditComponent } from "./task-amendment/task-amendment-edit/task-amendment-edit.component";
import { TaskAmendmentComponent } from "./task-amendment/task-amendment.component";
import { ImmTemplateGeneratorComponent } from "./template-generator/imm-template-generator/imm-template-generator.component";
import { GovTemplateGeneratorComponent } from './Govtemplate-generator/gov-template-generator/gov-template-generator.component';
import { TemplateGeneratorComponent } from "./template-generator/template-generator.component";
import { TemplateSelectorComponent } from "./template-generator/template-selector/template-selector/template-selector.component";
import { UserModule } from "./user/user.module";
import { ImmDocumentVisamappingComponent } from "./imm-document-visamapping/imm-document-visamapping.component";
import { ImmDocumentVisamappingEditComponent } from "./imm-document-visamapping/imm-document-visamapping-edit/imm-document-visamapping-edit.component";
import { FormsModule } from "@angular/forms";
import { GovernanceDocTypesComponent } from './governance-doc-types/governance-doc-types.component';
import { GovernanceActivitiesComponent } from './governance-activities/governance-activities.component';
import { GovernanceDocTypesEditComponent } from './governance-doc-types/governance-doc-types-edit/governance-doc-types-edit.component';
import { GovernanceNewdocTypesComponent } from './governance-newdoc-types/governance-newdoc-types.component';
import { GovernanceNewdocTypesEditComponent } from './governance-newdoc-types/governance-newdoc-types-edit/governance-newdoc-types-edit.component';
import { GovernanceActivitiesEditComponent } from './governance-activities/governance-activities-edit/governance-activities-edit.component';
import { GovernanceDocMappingComponent } from './governance-doc-mapping/governance-doc-mapping.component';
import { GovernanceDocMappingEditComponent } from './governance-doc-mapping/governance-doc-mapping-edit/governance-doc-mapping-edit.component';

@NgModule({
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    HeaderComponent,
    FooterComponent,
    NotFoundComponent,
    LoginComponent,
    SigninOidcComponent,
    LogoutComponent,
    AppSettingsComponent,
    TemplateGeneratorComponent,
     GuestLayoutComponent,
    AuthorisedLayoutComponent,
     LandingPageComponent,
    TemplateSelectorComponent,
    TaskAmendmentComponent,
    TaskAmendmentEditComponent,
    ImmTemplateGeneratorComponent,
    GovTemplateGeneratorComponent,
    LookupTypeAmendmentComponent,
    LookupTypeAmendmentEditComponent,
    PrivacyPolicyComponent,
    LookupTypeAmendmentEditComponent,
    ImmTaskAmendmentComponent,
    ImmTaskAmendmentEditComponent,
    ExitTaskAmendmentComponent,
    ExitTaskAmendEditComponent,
    ExitTemplateGeneratorComponent,
    ImmDocumentVisamappingComponent,
    ImmDocumentVisamappingEditComponent,
    GovernanceDocTypesComponent,
    GovernanceActivitiesComponent,
    GovernanceDocTypesEditComponent,
    GovernanceNewdocTypesComponent,
    GovernanceNewdocTypesEditComponent,
    GovernanceActivitiesEditComponent,
    GovernanceDocMappingComponent,
    GovernanceDocMappingEditComponent
  ],
  bootstrap: [AppComponent,MsalRedirectComponent],
  imports: [
     BrowserModule,
     BrowserAnimationsModule,
    NgbModalModule,
    NgbDropdownModule,
    NgbPopoverModule,
     SharedModule,
     AppRoutingModule, 
    EditorModule,
    AdminModule,
    NgMultiSelectDropDownModule,
    PaginationModule,
    UserModule,
    MsalModule,
    NgbModule
  ],
  providers: [
    AuthApi,
    UserApi,
    LookupApi,
    DocumentUploadService,
    OpenFilePreviewService,
    AttachmentUploadService,
    CSVReportService,
    CandidateApi,
    CommonService,
    EmailApi,
    PBApi,
    LoaderService,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    AntiForgeryResolver,
    
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: XsrfInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: API_BASE_URL, useFactory: getApiBaseUrl },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}

export function getApiBaseUrl(): string {
  return environment.apiBaseUrl;
}
